import { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/ProfilePage.css";
import ProfileTab from "./profile-tabs/ProfileTab.js";
import SettingsTab from "./profile-tabs/SettingsTab.js";
import { useProfile } from "../../services/hooks/getSuperAdminApis.js"
import { ShimmerThumbnail } from "react-shimmer-effects";
import SuperAdminSidebar from "./SuperAdminSidebar.js";
import { FaUserSecret } from "react-icons/fa6";
import SuperAdminHeader from "./SuperAdminHeader.js";


// ProfileCard Component==========================================
const ProfileCard = () => {
  const [key, setKey] = useState("profile");
   const [fetchLoading, setFetchLoading] = useState(true);

// getting profile data
  const { data: profile, isLoading } = useProfile();

   useEffect(() => {
  if (!isLoading) {
    setFetchLoading(false);
  }
}, [isLoading]);

  useEffect(() => {
    document.title = "Profile | Bitstek Advisory"; // Set the document title
  }, []);

  const [showModal, setShowModal] = useState(false);
  const [activeSection, setActiveSection] = useState("");
  const [data, setData] = useState({
    crypto: null,
    bank: null,
    upi: null,
  });

  const handleShow = (section) => {
    if (section === "profile") {
      setKey("profile");
    } else {
      setActiveSection(section);
      setShowModal(true);
    }
  };

  const handleClose = () => setShowModal(false);

  const handleSave = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const newData = Object.fromEntries(formData);
    setData((prev) => ({ ...prev, [activeSection]: newData }));
    handleClose();
  };

  const KYCStatus = profile?.KYC_Status || "Pending"; // Default value if undefined
   const Email = profile?.isEmailVerified ? "Verified" : "Not Verified";

  return (
    <>
    <div className="card profile-card text-center">
     {fetchLoading ? (
      <div className="shimmer-container">
        <div className="shimmer-effect">
          <ShimmerThumbnail row={2} col={2} card frameHeight={1000} />
        </div>
      </div>
    ) : (
      <div className="card-body">
        <div className="pro-img">
          <FaUserSecret className="super-admin-profile-icon" />
          <br></br>
          <small style={{ color: "green" }}><b>Super Admin</b></small>
        </div>
        <br />
        <h3 className="pb-2 profile-name">{profile?.FullName || "Guest"}</h3>
        <hr />
        <div className="row">
        {/* <Col className="side-border"> */}
          <div className="col-md-6 col-sm-12 col-6 border-right">
            <small><b>Email:</b></small>
            <br />
            <p className="status-text">
              <span className="status_label verified">{Email ? "verified" : "NotVerified"}</span>
            </p>
          </div>
          {/* </Col> */}
          <div className="col-md-6 col-sm-12 col-6">
            <small><b>SuperAdmin</b></small>
            <br />
            <p className="status-text">
             <span className={`status_label ${KYCStatus === "Pending" ? "pending" : KYCStatus === "Rejected" ? "Rejected" : "verified"}`}>
                  {KYCStatus}
             </span>
            </p>
          </div>
         
        </div>
      </div>
    )}
    </div>
    </>
  );
};

// Profile Component
const SuperAdminProfile = () => {
  const [activeTab, setActiveTab] = useState("Profile");

  return (
    <>
    <SuperAdminHeader page="dashboard" />
    <SuperAdminSidebar />
      <div className="transactions-history">

        <div className="row mt-3">
          <div className="col-lg-4 col-md-4 col-xs-12">
            <ProfileCard />
          </div>

          <div className="col-lg-8 col-md-8 col-xs-12">
            <p id="Page_MsgBox"></p>
            <div className="card1">
              <ul className="nav nav-tabs profile-tab" role="tablist">
                {[ 'Profile', 'Settings'].map(tab => (
                  <li className="nav-item" key={tab}>
                    <button className={`nav-link ${activeTab === tab ? 'active' : ''}`} onClick={() => setActiveTab(tab)}>
                      {tab}
                    </button>
                  </li>
                ))}
              </ul>

              <div className="tab-content">
                {/* {activeTab === "KYC" && <KYCTab />} */}
                {activeTab === "Profile" && <ProfileTab />}
                {activeTab === "Settings" && <SettingsTab />}
                {/* {activeTab === "Payment-Details" && <PaymentDetailsTab />} */}
               
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SuperAdminProfile;